import styled from "styled-components";

export const StyledCareerManagers = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  & .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  & .header-container {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    gap: 20px;
  }

  & .search-container {
    width: 250px;
  }

  & .filters-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 16px;
    flex-wrap: wrap;
  }

  & .table-container {
    width: 100%;
  }
`;
